/* eslint-disable import/prefer-default-export */

import { RESET_PRODUCT } from './types';

export const resetProduct = () => ({
  type: RESET_PRODUCT,
});
